import axios from 'axios';

let scriptPromise;

/**
 * Load Google Identity Services script once.
 */
export function loadGoogleIdentityScript() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('No window'));
  }
  if (window.google?.accounts?.id) {
    return Promise.resolve();
  }
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-google-gsi]');
    if (existing) {
      if (window.google?.accounts?.id) {
        resolve();
        return;
      }
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', () => reject(new Error('Google script failed')));
      return;
    }
    const s = document.createElement('script');
    s.src = 'https://accounts.google.com/gsi/client';
    s.async = true;
    s.defer = true;
    s.dataset.googleGsi = '1';
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('Failed to load Google Sign-In'));
    document.head.appendChild(s);
  });
  return scriptPromise;
}

/**
 * Web client ID: build-time env, or runtime from API (same value as backend GOOGLE_CLIENT_ID).
 */
export async function resolveGoogleClientId() {
  const fromEnv = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  if (fromEnv && String(fromEnv).trim()) {
    return { clientId: fromEnv.trim(), enabled: true };
  }
  try {
    const { data } = await axios.get('/api/auth/google-config');
    const clientId = (data && data.clientId) || '';
    return { clientId, enabled: Boolean(data && data.enabled && clientId) };
  } catch {
    return { clientId: '', enabled: false };
  }
}

/** Decode Google credential JWT payload for UI prefill only (not verified). */
export function parseGoogleCredentialEmail(credential) {
  if (!credential || typeof credential !== 'string') return null;
  try {
    const part = credential.split('.')[1];
    if (!part) return null;
    const b64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
    const json = atob(padded);
    const payload = JSON.parse(json);
    return payload.email || null;
  } catch {
    return null;
  }
}
